import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import * as Sentry from '@sentry/react'
import { useAuthStore } from '@/stores/auth-store'
import { useOrganizationStore } from '@/stores/organization-store'

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor - add auth token
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const { accessToken } = useAuthStore.getState()
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor - handle 401 and report 5xx to Sentry
api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - clear context and logout user
      useOrganizationStore.getState().clearContext()
      useAuthStore.getState().logout()
      window.location.href = '/login'
    }
    if (error.response && error.response.status >= 500) {
      Sentry.captureException(error)
    }
    return Promise.reject(error)
  }
)

export default api
